import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import type { MembershipLevelForm } from '@/pages/MembershipLevelsPage.types'

export function MembershipLevelJoinFormSettings({
  form,
  onChange,
}: {
  form: MembershipLevelForm
  onChange: (form: MembershipLevelForm) => void
}) {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-body-sm text-foreground">Public join form</span>
      <JoinFormCheckbox
        id="membership-level-published-to-join-form"
        label="Publish to join form"
        checked={form.publishedToJoinForm}
        onCheckedChange={(checked) => onChange({ ...form, publishedToJoinForm: checked })}
      />
      <JoinFormCheckbox
        id="membership-level-requires-admin-approval"
        label="Require admin approval"
        checked={form.requiresAdminApproval}
        onCheckedChange={(checked) => onChange({ ...form, requiresAdminApproval: checked })}
      />
    </div>
  )
}

function JoinFormCheckbox({
  id,
  label,
  checked,
  onCheckedChange,
}: {
  id: string
  label: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}) {
  return (
    <div className="flex items-start gap-2">
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(nextChecked) => onCheckedChange(nextChecked === true)}
      />
      <Label htmlFor={id} className="text-foreground">
        {label}
      </Label>
    </div>
  )
}
